import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="mansionInfo";

export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectAllByQueryText(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAllByQueryText`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function selectListByQuery(parameter){
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectListByQuery`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectListStatistic(parameter){
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAllStatistic`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}



export function listAll(parameter){
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/listAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function listByRegion(parameter){
  return axios({
    url: `/ws/${moduleName}/listByRegion`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectOne(mansionId,type){
  console.log("id:",mansionId)
  return axios({
    url: `/ws/${moduleName}/${mansionId}/${type}`,
    method: 'get',
  })
}

export function getCitys(){
  return axios({
    url: `/ws/${moduleName}/getCitys`,
    method: 'get',
  })
}

export function selectProjectMansions(companyId){
  return axios({
    url: `/ws/${moduleName}/selectProjectMansions`,
    method: 'get',
    params:{companyId:companyId}
  })
}


export function selectAddProjectMansions(companyId){
  return axios({
    url: `/ws/${moduleName}/selectAddProjectMansions`,
    method: 'get',
    params:{companyId:companyId}
  })
}


export function updateMansionResearch(mansionId,whetherResearch) {
  return axios({
    url: `/ws/${moduleName}/updateMansionResearch/${mansionId}/${whetherResearch}`,
    method: 'put'
  })
}

export function updateMansionAgent(mansionId,agent) {
  return axios({
    url: `/ws/${moduleName}/updateMansionAgent/${mansionId}/${agent}`,
    method: 'put'
  })
}

export function deleteMansionById(mansionId) {
  return axios({
    url: `/ws/${moduleName}/deleteMansionById/${mansionId}`,
    method: 'put'
  })
}

export function selectByIds(mansionIds){
  console.log("id:",mansionIds)
  let parameter = {idList: mansionIds}
  return axios({
    url: `/ws/${moduleName}/selectByIds`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function saveMansion(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/saveMansion`,
    method: 'post',
    data:parameter
  })
}

export function updateImportantLeavel(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateImportantLeavel`,
    method: 'put',
    data:parameter
  })
}



export function updateMansion(parameter) {
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateMansion`,
    method: 'put',
    data:parameter
  })
}


export function updateOption(parameter) {
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateOption`,
    method: 'put',
    data:parameter
  })
}

export function getMansionData(){
  return axios({
    url: `/ws/${moduleName}/getMansionData`,
    method: 'get'
  })
}

export function exportMansionPPT(parameter){
  console.log('parm',JSON.stringify(parameter))
  return axios({
    url: `/ws/${moduleName}/exportMansionPPT`,
    method: 'post',
    // headers: {'Content-Type': 'application/json; charset=utf-8'},
    data: parameter,
    responseType: 'blob',
    paramsSerializer: data => {
      return qs.stringify(data, { indices: false })
    }
  })
}

export function exportMansionPPTAsync(parameter){
  console.log('parm',JSON.stringify(parameter))
  return axios({
    url: `/ws/${moduleName}/exportMansionPPT`,
    method: 'post',
    // headers: {'Content-Type': 'application/json; charset=utf-8'},
    data: parameter,
    paramsSerializer: data => {
      return qs.stringify(data, { indices: false })
    }
  })
}

export function getImportantLeavelUpdateInfo(id){
  return axios({
    url: `/ws/${moduleName}/getImportantLeavelUpdateInfo/${id}`,
    method: 'get'
  })
}

export function importMansionRentVacancyRate(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/importMansionRentVacancyRate`,
    method: 'post',
    data:parameter
  })
}


export default {
  selectListByQuery,
  selectAll,
  selectOne,
  saveMansion,
  updateMansion,
  updateMansionAgent,
  listAll,
  listByRegion,
  selectAllByQueryText,
  getMansionData,
  exportMansionPPT,
  exportMansionPPTAsync,
  selectByIds,
  getCitys,
  updateOption,
  getImportantLeavelUpdateInfo,
  updateImportantLeavel,
  updateMansionResearch,
  selectAddProjectMansions,
  selectProjectMansions,
  selectListStatistic,
  deleteMansionById,
  importMansionRentVacancyRate
}
